import { defineStore } from 'pinia';
import type {
  PdpRecommendedProductsAttribution,
  PdpRecommendedProductsAttributionOptions
} from '~/utils/pdpRecommendedProductsAnalytics/types';
import {
  PDP_RECOMMENDED_PRODUCTS_ITEM_LIST_ID,
  PDP_RECOMMENDED_PRODUCTS_ITEM_LIST_NAME
} from '~/utils/pdpRecommendedProductsAnalytics/types';

export const usePdpRecommendedProductsAnalyticsStore = defineStore(
  'pdpRecommendedProductsAnalytics',
  () => {
    const attributionBySku = ref<
      Record<string, PdpRecommendedProductsAttribution>
    >({});

    function registerAttribution(
      sku: string,
      options: PdpRecommendedProductsAttributionOptions
    ): void {
      attributionBySku.value = {
        ...attributionBySku.value,
        [sku]: {
          pdp_category: options.pdp_category,
          pdp_result_position: options.pdp_result_position,
          pdp_main_product_sku: options.pdp_main_product_sku,
          item_list_id: PDP_RECOMMENDED_PRODUCTS_ITEM_LIST_ID,
          item_list_name: PDP_RECOMMENDED_PRODUCTS_ITEM_LIST_NAME,
          selected_via_pdp_dropdown: true
        }
      };
    }

    function getAttribution(
      sku: string
    ): PdpRecommendedProductsAttribution | undefined {
      return attributionBySku.value[sku];
    }

    function hasAttributionInCart(skus: string[]): boolean {
      return skus.some((sku) => attributionBySku.value[sku] != null);
    }

    function clearAttributions(): void {
      attributionBySku.value = {};
    }

    return {
      attributionBySku: computed(() => attributionBySku.value),
      registerAttribution,
      getAttribution,
      hasAttributionInCart,
      clearAttributions
    };
  }
);
